import 'css-chunksrc/client/scenes/moveElement/styles.scss';export default {
  "moveElement": "_moveElement_8nu18_1",
  "body": "_body_8nu18_5",
  "footer": "_footer_8nu18_14",
  "button": "_button_8nu18_22",
  "conserveTime": "_conserveTime_8nu18_27",
  "conserveTimeDescription": "_conserveTimeDescription_8nu18_33"
};